<template>
  <div class="rounded-lg border border-gray-200 p-3 mb-4 shadow-sm">
    <div class="flex items-center justify-between">
      <div class="flex items-center gap-2 flex-1 min-w-0">
        <span class="section-heading-number text-sm">1</span>
        <span class="text-sm font-medium text-gray-700">{{ $t('message.intentionHeading') }}:</span>
        <span class="text-sm text-gray-900 font-semibold truncate">{{ payload || '-' }}</span>
      </div>
      <span class="help-button" @click="$emit('open-help-modal')">
        <QuestionMarkCircleIcon class="h-5 w-5" />
      </span>
    </div>
  </div>
</template>

<script>
import { QuestionMarkCircleIcon } from '@heroicons/vue/24/outline'

export default {
  name: 'Step1_Intention',
  components: {
    QuestionMarkCircleIcon
  },
  props: {
    payload: String
  }
}
</script>
